import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledLabelMainColor } from './styles/StyledLabelMainColor';
import { StyledLabelMainColorLower } from './styles/StyledLabelMainColorLower';


class LabelMainColor extends Component {
  render() {
    const { title, type } = this.props;

    return (
      type === "h2" ? (
        <StyledLabelMainColor>
          { title }
        </StyledLabelMainColor>
      ) : (
        <StyledLabelMainColorLower>
          { title }
        </StyledLabelMainColorLower>
      )
    );
  }
}

LabelMainColor.defaultProps = {
  tpye: 'h2',
};

LabelMainColor.propTypes = {
  title: PropTypes.string.isRequired,
};


export default LabelMainColor;


// WEBPACK FOOTER //
// ./src/common/LabelMainColor/LabelMainColor.js